<template>
<div class="counting-container">
    <Row type="flex">
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">动电极</div>
            <Row type="flex">
                <Col flex="1">
                    修磨报警焊点数
                </Col>
                <Col>
                    <InputNumber type="number" v-model="systemData.E2ThrMovDrsAlm" />
                </Col>
            </Row>
            <Row type="flex">
                <Col flex="1">
                    修磨预警焊点数
                </Col>
                <Col>
                    <InputNumber  type="number" v-model="systemData.E2ThrMovDrsWarn" />
                </Col>
            </Row>
            <Row type="flex">
                <Col flex="1">
                    更换报警阈值
                </Col>
                <Col>
                    <InputNumber  type="number" v-model="systemData.E2ThrMovChgAlm" />
                </Col>
            </Row>
              <Row type="flex">
                <Col flex="1">
                    更换预警值
                </Col>
                <Col>
                    <InputNumber  type="number" v-model="systemData.E2ThrMovChgWarn" />
                </Col>
            </Row>
             
        </Card>
        </Col>
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">静电极</div>
            <Row type="flex">
                <Col flex="1">
                    修磨报警焊点数
                </Col>
                <Col>
                    <InputNumber  type="number" v-model="systemData.E2ThrFixDrsAlm" />
                </Col>
            </Row>
            <Row type="flex">
                <Col flex="1">
                    修磨预警焊点数
                </Col>
                <Col>
                    <InputNumber  type="number" v-model="systemData.E2ThrFixDrsWarn" />
                </Col>
            </Row>
              <Row type="flex">
                <Col flex="1">
                    更换报警阈值
                </Col>
                <Col>
                    <InputNumber type="number" v-model="systemData.E2ThrFixChgAlm" />
                </Col>
                 </Row>
                <Row type="flex">
                <Col flex="1">
                    更换预警值
                </Col>
                <Col>
                    <InputNumber  type="number" v-model="systemData.E2ThrFixChgWarn" />
                </Col>
           
            </Row>
           
        </Card>
        </Col>
    </Row>
     <Row type="flex" class="flex-middle">
                <Col flex="1">
                    <Button type="primary" @click="handleSave" :loading="loading">{{ getTranslation('c006') }}</Button>
                </Col>
            </Row>
</div>
</template>

<script>
import axios from 'axios';
import {
    API_URL
} from '@/constants/const'
import {
    mapGetters
} from 'vuex'
import {
    postJsError
} from '@/util/util.js'
export default {
    name: 'CountPanel',
    props: {
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            systemData: {},
            originalData: {},
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
    },
    async created() {
        this.init();
    },
    methods: {
        async init() {
            const url = API_URL['501SystemGet'];
            let params = {
                mac: this.mac
            }
            let res = await axios.get(url, {
                    params: params
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
                if (res.data.data.param) {
                    for (var i in res.data.data.param) {
                        this.$set(this.systemData, i, res.data.data.param[i])
                    }
                    // 保存原始值快照
                    this.originalData = JSON.parse(JSON.stringify(this.systemData))
                }
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        async handleSave() {
            // 只提交修改过的字段
            var changed = {}
            for (var key in this.systemData) {
                if (this.systemData[key] !== this.originalData[key]) {
                    changed[key] = this.systemData[key]
                }
            }
            if (Object.keys(changed).length === 0) {
                this.$Message.warning(this.getTranslation('a159'))
                return
            }
            this.loading = true
            let formData = new FormData();
            formData.append('mac', this.mac);
            formData.append('param', JSON.stringify(changed));
            var res = await axios.post(API_URL['501SystemDownload'], formData).catch((err) => {
                postJsError(err)
                this.$Message.error(this.getTranslation('c001'))
            })
            if (res && res.data && res.data.code == 200) {
                this.$Message.success(res.data.msg)
                await this.init()
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg)
            } else {
                this.$Message.error(this.getTranslation('c001'))
            }
            this.loading = false
        },
    }
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');

.counting-container {
    padding: 10px;
}
</style>
